module.exports = __webpack_public_path__ + "img/y.01776212.jpg";